import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { inTaskCommands } from './TaskCommands';
import { AssociatedTaskExportAdapter } from './TaskExports';
import { TaskMechanics } from './TaskMechanics';
import { TaskRecordManager } from './TaskRecordManager';

export class TaskPackage implements Package {

    public install = (host: PackageHost) => host
        .register(TaskRecordManager, 'singleton', 'startable')
        .register(TaskMechanics, 'singleton', 'startable')
        .plug(inTaskCommands())
        .plug(inExportAdapter(AssociatedTaskExportAdapter));
}
